import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ImportedDetectorBoardsComponent } from './imported-detector-boards/imported-detector-boards.component';

const routes: Routes = [
  {
    path: '',
    component: ImportedDetectorBoardsComponent,
    data: {
      title: 'Import Sensor Boards',
      urls: [
        { title: 'Dashboard', url: '/' },
        { title: 'Import Sensor Boards' },
      ],
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ImportDetectorBoardRoutingModule {}
